import * as XLSX from "xlsx";
import getCoordinates from "./getCoordinates";

async function excelToJson(file: File): Promise<any[]> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async (event) => {
      try {
        const data = new Uint8Array(event.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, {
          type: "array",
          cellText: true,
          cellNF: true,
        });

        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        const headers = jsonData[0] as string[];
        const rows = jsonData.slice(1) as any[][];

        const result = await Promise.all(
          rows.map(async (row: any[], rowIndex: number) => {
            const rowObject: Record<string, any> = {};

            headers.forEach((header, colIndex) => {
              if (header === "dateOfSeizure") {
                const cellAddress = XLSX.utils.encode_cell({
                  c: colIndex,
                  r: rowIndex + 1,
                });
                const cell = worksheet[cellAddress];

                if (cell?.v) {
                  const jsDate = XLSX.SSF.parse_date_code(cell.v);
                  if (jsDate) {
                    const date = new Date(jsDate.y, jsDate.m - 1);
                    const monthYear = date.toLocaleString("default", {
                      month: "long",
                      year: "numeric",
                    }).replace(" ", "-");
                    rowObject[header] = monthYear; // e.g., "April-2024"
                  } else {
                    rowObject[header] = "Invalid Date";
                  }
                } else {
                  rowObject[header] = "N/A";
                }
              } else {
                rowObject[header] = row[colIndex] || "N/A";
              }
            });

            if (rowObject["no"]) {
              rowObject["no"] = "" + rowObject["no"];
            }

            if (
              rowObject["location"] &&
              rowObject["location"] !== "0" &&
              rowObject["location"] !== "N/A"
            ) {
              try {
                const coordinates = await getCoordinates(rowObject["location"]);
                rowObject["latitude"] = coordinates.lat;
                rowObject["longitude"] = coordinates.lon;
              } catch (error) {
                rowObject["latitude"] = null;
                rowObject["longitude"] = null;
                console.error(
                  `Failed to geocode location: ${rowObject["location"]}`,
                  error
                );
              }
            } else {
              rowObject["latitude"] = null;
              rowObject["longitude"] = null;
            }

            return rowObject;
          })
        );

        resolve(result);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsArrayBuffer(file);
  });
}

export default excelToJson;
